export default __webpack_public_path__ + "static/media/white_logo.0655945b.png";